import { useState } from "react";
import icon from "../../assets/images/pcon.svg"
import NavigationBar from "../../components/01_navigationBar/01_navigationBar";
import Footer from "../../components/02_footer/02_footer";

import "./06_appointmentPage.css"

export default function Appointment() {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setMessage("");

        try {
            const response = await fetch("https://easyhear.in/bookapt.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: name,
                    phone: phone,
                }),
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(data.message || "Failed to send WhatsApp message");
            }

            setMessage("Message sent successfully!");
            setName("");
            setPhone("");
        } catch (error) {
            console.error(error);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <NavigationBar />
            <div className="AppointmentPage-HeroSection">
                <h1 className="Title">Take the First Step Toward Better Hearing</h1>
                <p>Book your free hearing consultation. Get expert, personalized guidance to find the right hearing solution for your needs—without pressure.</p>
            </div>
            <form className="AppointmentPage-Form" onSubmit={handleSubmit}>
                <div className="AppointmentPage-Form-Group">
                    <label htmlFor="name">Your Name</label>
                    <input
                        id="name"
                        type="text"
                        placeholder="Enter your full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <div className="AppointmentPage-Form-Group">
                    <label htmlFor="phone">Phone No.</label>
                    <input
                        id="phone"
                        type="tel"
                        placeholder="Enter your phone number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Submit"}
                </button>

                {message && <p>{message}</p>}
            </form>
            <div className="AppointmentPage-StepSection">
                <h2>Your Journey to Better Hearing Starts Here</h2>
                <div className="AppointmentPage-StepSection-Flex">
                    <div className="AppointmentPage-StepSection-Flex-Card">
                        <span>Step 1</span>
                        <h3>Fill Out the Form</h3>
                        <p>
                            Share a few basic details about yourself and your hearing needs. It only takes a moment to request your appointment.
                        </p>
                    </div>
                    <div  className="AppointmentPage-StepSection-Flex-Card">
                        <span>Step 2</span>
                        <h3>Our Team Will Contact You</h3>
                        <p>
                            One of our hearing care experts will reach out to understand your requirements, answer your questions, and help schedule a convenient time</p>
                    </div>
                    <div  className="AppointmentPage-StepSection-Flex-Card">
                        <span>Step 3</span>
                        <h3>Enjoy a Free Consultation</h3>
                        <p>
                            Meet with our hearing care team for a free consultation. Discuss your hearing concerns, explore your options, and get personalized guidance based on your lifestyle and needs.
                        </p>
                    </div>
                </div>
            </div>
            <h1 className="AppointmentPage-FAQSection-Heading">Frequently asked questions</h1>
            <div className="AppointmentPage-FAQSection-Flex">
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>How do I know which hearing aid is right for me?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        The right hearing aid depends on factors such as your hearing needs, lifestyle, comfort preferences, and budget. Our experts will help you understand your options and recommend a solution suited to you.
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>Is the hearing consultation really free?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        Yes. Your initial consultation is free. Our team will understand your hearing concerns and guide you on the most suitable next steps. 
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>Do I need a hearing test before getting hearing aids?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        Not necessarily. During your consultation, our hearing care experts can understand your concerns and recommend whether a professional hearing test would be appropriate.
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>Do you provide hearing aid repairs and support?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        Yes. We provide ongoing expert support and hearing aid repair services to help you get the most from your hearing solution over time.
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>Do you help people of all ages?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        Yes. Hearing care can be personalized for different ages and lifestyles. Our team will help identify the right approach based on your individual needs.
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>What happens after I submit the appointment form?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        Once you submit the form, a member of our team will contact you to understand your requirements and help arrange your consultation at a convenient time. 
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>Will I be pressured to purchase a hearing aid?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        No. Our goal is to provide clear, personalized guidance so you can make an informed decision about your hearing care.
                    </p>
                </details>
                <details className="AppointmentPage-FAQSection-Card">
                    <summary className="AppointmentPage-FAQSection-Card-Info">
                        <h3>How long does the appointment take?</h3> 
                        <img src={icon} alt="" />
                    </summary>
                    <p className="AppointmentPage-FAQSection-Card-Details">
                        The duration can vary depending on your needs and whether a hearing assessment or additional evaluation is required. Our team will provide the relevant details when confirming your appointment.
                    </p>
                </details>
            </div>
            <Footer />
        </div>
    );
}